const config = {
  website: 'https://zoucam.com',
};

export { config };
